import React, { useState } from 'react';
import Loader from "react-loader-spinner";
import { MdClose } from 'react-icons/md';
import * as jobsActions from '../../Redux/Actions/jobs';
import { toastMessage } from '../../utils/toast';

const PaymentLink = ({ t, showModal, loading, handleCancel, data }) => {

    const [buttonLoading, setButtonLoading] = useState(false);
    const [errMessge, setErrMessage] = useState('')
    const handleRequest = () => {
        setButtonLoading(true);
        jobsActions.PaymentLink(data).then(res => {
            toastMessage('success', res.data?.message || 'Success');
            setButtonLoading(false);
            handleCancel();
            window.location.reload();
        }).catch(err => {
            setButtonLoading(false);
            setErrMessage(err?.response?.data?.Message)
            // toastMessage('error', err?.response?.data?.Message || 'Try again later');
        });
    }

    return (
        <div>
            <div className="modal" style={{ display: (showModal ? 'block' : '') }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{"Conformation"}</h5>
                            <button type="button" className="close" aria-label="Close" onClick={handleCancel} style={{ border: 'none' }}>
                                <MdClose />
                            </button>
                        </div>
                        <div className="modal-body">
                            {errMessge == '' ? (<p>{"Are You Sure ?"}</p>) : (<p style={{ fontWeight: 'bold', color: 'red' }}>{errMessge}</p>)}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-light-danger font-weight-bold" disabled={loading || buttonLoading} onClick={handleCancel}>{t("jobsManagement.infoJob.receiptStatus.cancel")}</button>
                            <button type="button" className="btn btn-primary font-weight-bold d-flex align-items-center" disabled={loading || buttonLoading} onClick={() => { errMessge == '' ? handleRequest() : handleCancel() }}>
                                {errMessge === '' ? "Yes " : "Ok "} {(loading || buttonLoading) && <Loader type="Oval" color="#fff" height={20} width={20} style={{ marginLeft: '10px' }} />}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </div>
    );
};

export default PaymentLink;